import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, ArrowUpRight } from 'lucide-react';
import MapPopup from './MapPopup';

const Contact = () => {
  const [isMapOpen, setIsMapOpen] = useState(false);

  return (
    <section className="relative bg-[#071a2b] py-32 px-8 md:px-16 overflow-hidden">
      
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-[#78BE20] opacity-[0.03] blur-[120px] rounded-full mix-blend-screen" />
        <div className="absolute bottom-0 right-1/4 w-[600px] h-[600px] bg-[#4a90e2] opacity-[0.03] blur-[150px] rounded-full mix-blend-screen" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8">
          
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5 pt-4"
          >
            <div className="flex items-center gap-4 mb-10">
              <div className="h-[1px] w-12 bg-[#78BE20]/50" />
              <span className="text-[10px] uppercase tracking-[0.4em] text-[#78BE20] font-bold">
                Get In Touch
              </span>
            </div>
            
            <h2 className="text-6xl md:text-8xl font-serif text-white leading-tight mb-10">
              Contact <span className="text-white/30">Us</span>
            </h2>
            
            <div className="relative pl-8">
               <div className="absolute left-0 top-0 bottom-0 w-[1px] bg-white/10" />
               <p className="text-lg text-white/50 font-light leading-relaxed max-w-sm">
                You may contact us with your queries, and we will get back to you promptly.
              </p>
            </div>
          </motion.div>

          <div className="lg:col-span-7 grid md:grid-cols-2 gap-6 items-stretch">
            
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="bg-white/[0.03] border border-white/5 rounded-xl p-10 flex flex-col justify-between hover:bg-white/[0.05] transition-colors"
            >
              <div>
                <div className="flex items-center gap-3 mb-12">
                  <Phone size={18} className="text-[#78BE20]" />
                  <span className="text-[11px] uppercase tracking-[0.3em] text-white/40 font-bold">Details</span>
                </div>
                
                <div className="space-y-10">
                  <div className="group/item">
                    <p className="text-[10px] uppercase tracking-widest text-white/30 mb-2 font-medium">Phone</p>
                    <a href="tel:+919810476281" className="text-xl md:text-2xl text-white hover:text-[#78BE20] transition-colors block">
                      +91-9810476281
                    </a>
                  </div>

                  <div className="w-full h-[1px] bg-white/5" />

                  <div className="group/item">
                    <p className="text-[10px] uppercase tracking-widest text-white/30 mb-2 font-medium">Email</p>
                    <a href="mailto:anshoo@lcaas.in" className="text-xl md:text-2xl text-white hover:text-[#78BE20] transition-colors block">
                      anshoo@lcaas.in
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="bg-white/[0.03] border border-white/5 rounded-xl p-10 flex flex-col justify-between hover:bg-white/[0.05] transition-colors"
            >
              <div>
                <div className="flex items-center gap-3 mb-12">
                  <MapPin size={18} className="text-[#78BE20]" />
                  <span className="text-[11px] uppercase tracking-[0.3em] text-white/40 font-bold">Office Address</span>
                </div>
                
                <div className="pr-4">
                  <p className="text-xl text-white/90 leading-relaxed font-light">
                    81, Emilia 5, Vatika City
                  </p>
                  <p className="text-sm text-white/40 mt-4 leading-relaxed tracking-wide">
                    Golf Course Extension, Sector - 49, Gurugram - 122018
                  </p>
                </div>
              </div>

              <div className="mt-12">
                <button 
                  onClick={() => setIsMapOpen(true)}
                  className="inline-flex items-center gap-3 text-[10px] uppercase tracking-[0.3em] font-bold text-[#78BE20] group/btn"
                >
                  Get Directions
                  <ArrowUpRight size={14} className="group-hover/btn:translate-x-1 group-hover/btn:-translate-y-1 transition-transform" />
                </button>
              </div>
            </motion.div>

          </div>
        </div>
      </div>

      <MapPopup isOpen={isMapOpen} onClose={() => setIsMapOpen(false)} />
    </section>
  );
};

export default Contact;